import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth, formatApiError } from "../../context/AuthContext";
import { LOGO_URL } from "../../lib/api";
import { BackgroundGrid } from "../../components/site/RouteLine";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user && user.email) nav("/admin/dashboard"); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  const field = "w-full bg-[#0B132B] border border-white/10 rounded-lg px-4 py-3 text-sm text-white placeholder:text-gray-500 focus:border-[#D4AF37] focus:outline-none";

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden bg-[#060A17] px-4" data-testid="admin-login-page">
      <BackgroundGrid className="opacity-30" />
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }}
        className="relative w-full max-w-md nm-card rounded-2xl p-8">
        <img src={LOGO_URL} alt="Next Mile Compliance" className="h-14 w-auto object-contain mx-auto mb-6" />
        <div className="flex items-center justify-center gap-2 mb-1">
          <Lock size={15} className="text-[#D4AF37]" />
          <h1 className="font-head text-xl font-bold text-white text-center">Admin Login</h1>
        </div>
        <p className="text-gray-400 text-xs text-center mb-7">Manage leads, content, and testimonials.</p>
        <form onSubmit={submit} className="space-y-4">
          <input className={field} type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
          <input className={field} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
          <button type="submit" disabled={loading}
            className="btn-sheen w-full flex items-center justify-center gap-2 nm-gold-bg text-[#0B132B] font-bold py-3 rounded-full disabled:opacity-60"
            data-testid="admin-login-submit">
            {loading && <Loader2 className="animate-spin" size={17} />}{loading ? "Signing in..." : "SIGN IN"}
          </button>
        </form>
        <a href="/" className="block text-center text-xs text-gray-500 hover:text-[#D4AF37] mt-6">← Back to website</a>
      </motion.div>
    </div>
  );
}
